import { ol_Feature, ol_FeatureLike, ol_Map, ol_style } from "@omnia/exports/openlayers";
import { Layer } from "./layer";
import { IMapSelectInteraction } from "./types";
import { setFeatureStyle } from "./utils";

export class MapSelectInteraction2 implements IMapSelectInteraction {

    private selectableLayers: Layer[] = [];

    private _active: boolean = true;

    private features: any[] = [];

    private _watchers: ((selectedFeatures: any[]) => void)[] = [];

    private _multiselect: boolean;


    constructor(olmap: ol_Map, private canSelectFeaturePredicate?: (feature: any) => boolean) {

        this.setupInteraction(olmap);

    }

    dispose() {
        // NOP
    }

    setupInteraction(map: ol_Map) {

        map.on("click", e => {

            if (this._active) {

                var pixel = map.getEventPixel(e.originalEvent);

                var found = map.forEachFeatureAtPixel(pixel, (feature, olayer) => {

                    if (olayer && this.checkSelectableLayer(olayer)) {

                        if (this.canSelectFeature(feature)) {

                            if (this._multiselect) {
                                this.toggleFeatureSelection(feature);
                            }
                            else {
                                this.selectFeatures([feature]);
                            }

                            return true;

                        }

                    }


                });

                if (!found) {
                    this.selectFeaturesInternal([]);
                }

            }

        });

    }

    private canSelectFeature(feature: any): boolean {

        if (this.canSelectFeaturePredicate) {
            return this.canSelectFeaturePredicate(feature);
        }

        return true;

    }

    clearSelection() {

        this.selectFeaturesInternal([]);

    };

    selectFeatures(selection: any[]) {

        var features = this.features;

        if (features.length == selection.length) {

            if (selection.every((item, index) => features[index] == item)) {
                return;
            }

        }

        this.selectFeaturesInternal(selection);

    }


    toggleFeatureSelection(feature: any) {

        var index = this.features.indexOf(feature);

        if (index < 0) {
            this.selectFeaturesInternal(this.features.concat([feature]));
        } else {
            var features = this.features.slice();
            features.splice(index, 1);
            this.selectFeaturesInternal(features);
        }

    }

    selectFeature(feature) {

        this.selectFeatures([feature]);

    }


    private selectFeaturesInternal(features: any[]) {

        this.features.forEach(f => f.setStyle(null));

        this.features = features || [];

        this.features.forEach(f => this.setFeatureSelectedStyle(f));

        this.notifySelectionChanged();

    }


    private setFeatureSelectedStyle(feature: ol_Feature) {

        const layer = <Layer>feature.get("layer");

        if (layer) {
            setFeatureStyle(feature, layer.getLayerStyleFunction(true))
        }

    }

    refresh() {

        var features = this.features.slice();

        this.selectFeatures(features);

    }

    setLayers(layers: Layer[], resetSelection: boolean = true) {

        if (resetSelection) {
            this.clearSelection();
        }

        this.selectableLayers = layers || [];

    }

    addLayer(layer: Layer) {

        if (!this.selectableLayers.find(l => l == layer)) {
            this.selectableLayers.push(layer);
        }

    }

    removeLayer(layer: Layer) {

        this.selectableLayers.remove(l => l == layer);

    }

    private checkSelectableLayer(layer: any) {

        layer = this.selectableLayers.find((l) => l.mapLayer == layer);

        if (layer) return layer.selectable;

        return false;

    }

    setStyleProvider(provider: (feature: ol_FeatureLike, resolution: number) => ol_style.Style[]) {
        // Not suppoerted
    }

    get active(): boolean {
        return this._active;
    }

    set active(active) {
        this._active = active;
    }

    notifySelectionChanged() {

        var selection = this.features.slice();

        this._watchers.forEach(w => w(selection));

    }

    watchSelection(watcher: (selectedFeatures: any[]) => void) {

        if (!this._watchers.find(w => w == watcher)) {
            this._watchers.push(watcher);
        }

    }

    unwatchSelection(watcher: (selectedFeatures: any[]) => void) {
        this._watchers.remove(w => w == watcher);
    }

    get enableMultipleSelection() {
        return this._multiselect;
    }

    set enableMultipleSelection(value: boolean) {
        this._multiselect = value;
    }

    public getSelectedFeatures(): any[] {
        return this.features.slice();
    }

    public getSelectedFeaturesCount(): number {
        return this.features.length;
    }

}
